import * as React from 'react';
import { Icon } from '../icon';

export class DefaultTriggerComponent extends React.Component {
  render() {
    return <Icon name="pba-attachment" size={24} color="#B0BEC5" />;
  }
}
